<section class="modal" *ngIf="visible">
    <div class="container">
        <div class="headerModal">
            <p class="title">Detalle de Pedido</p>
            <button class="fas fa-times close" (click)="closeModal()"></button>
            <table>
                <tr class="rowHeader">
                    <th>Item</th>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                </tr>
                <tr class="rowDetail" *ngFor="let data of dataDetail; index as i">
                    <td>{{i+1}}</td>
                    <td>{{data.product}}<ng-container *ngIf="data.category==='hamburguesa'"> + {{data.totalAdditional}} Adicionales</ng-container></td>
                    <td>{{data.quantity}}</td>
                    <td>{{data.subtotal}}</td>
                </tr>
            </table>
        </div>
    </div>
</section>